import classnames from 'classnames'
import React, { FC, useContext } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { Button2 } from '../Button2/Button2'
import {
  getLogonCurrentTitle,
  getProfileCurrentTitle,
  getRegistrationCurrentTitle,
} from '../LocalizedButton/LocalizedButton'
import { LanguageContext } from '../LanguageContext/LanguageContext'
import { LocaleContext } from '../LocaleContext/LocaleContext'
import { CloseIcon } from './components/CloseIcon'
import style from './Wrapper.module.css'
import { UserContext } from '../UserContext/UserContext'

type WrapperProps = {
  isLoginForm?: boolean
  isThereCloseButton?: boolean
  children?: React.ReactNode
}

export const Wrapper: FC<WrapperProps> = ({ children, isLoginForm, isThereCloseButton }) => {
  const { locale } = useContext(LocaleContext)
  const { language } = useContext(LanguageContext)
  const { query, pathname } = useRouter()
  const updPage = pathname === '/updatepassword'
  const { user } = useContext(UserContext)

  const classNames = classnames(style.wrapper, {
    [style.isLoginForm]: isLoginForm,
    [style.mobileWrapper]: !query.widget,
  })

  const title = user
    ? getProfileCurrentTitle(locale, language)
    : isLoginForm || updPage
    ? getLogonCurrentTitle(locale, language)
    : getRegistrationCurrentTitle(locale, language)

  // const appHeight = () => {
  //   if (window.innerWidth <= 674) {
  //     const el = (document.getElementsByClassName(style.wrapper) as HTMLCollectionOf<HTMLElement>)[0];

  //     el.style.height = `${window.outerHeight}px`;
  //   }
  // };

  // вот эта штука нужна для фикса высоты мобильного сафари и андроид. Когда футер уезжает под меню
  // React.useEffect(() => {
  //   if (isLoginForm) {
  //     window.addEventListener('resize', appHeight);
  //     appHeight();
  //   }
  // }, []);

  const onCloseClick = () => {
    if (window.parent) {
      window.parent.postMessage(
        {
          isClose: true,
        },
        '*',
      )
    }
  }

  return (
    <div className={classNames}>
      <Head>
        <title>{title}</title>
      </Head>
      {children}
      {isThereCloseButton && (
        <Button2 onClick={onCloseClick} className={style.closeIcon}>
          <CloseIcon />
        </Button2>
      )}
    </div>
  )
}

Wrapper.displayName = 'Wrapper'
